import Provider         from "../../common/model/Provider";
import Config           from "../../common/model/Config";
import { webAccess }    from "../../common/controller/webAccessibilityCtrl";
import { regex }        from "../../common/utils/regex";
import { providerChk }  from "../../common/utils/provider.id.check";
import { mTransKey }    from "../../common/utils/mTransKeyEvt";
import { viewEvent }    from "./viewEventCtrl";

var rootId = "";
export const vaild = {    
    init: ()=>{
        rootId = Config.appendElementTagId;
    },
    nameCheck: (name)=>{
        if(name == "" ){
            viewEvent.view_msg("안내","","이름을 입력하여 주십시오.", ()=>{
                webAccess.targetFocus(`${rootId} [data-id='oacx_name']`);
                viewEvent.hidePopup();
            });
            return false;
        }else{
            if(!regex.isKorEng(name)){
                viewEvent.view_msg("안내","","이름은 한글, 영어만 입력 가능합니다.", ()=>{
                    webAccess.targetFocus(`${rootId} [data-id='oacx_name']`);
                    viewEvent.hidePopup();
                    $(`${rootId} [data-id='oacx_name']`).val("");
                });
                return false;
            }
            return true;
        }
    },
    birthCheck: (birth)=>{
        // 본인인증(Nice) CompareCI False 그리고 삼성패스일 때 생년월일, 주민등록번호 제외
        if(Provider.compareCI == false && providerChk.isSamsung(Provider.providerId)){
            return true;
        }
        
        if(birth==""){
            viewEvent.view_msg("안내","","생년월일을 입력하여 주십시오.",()=>{
                webAccess.targetFocus(`${rootId} [data-id='oacx_birth']`);
            });
            return false;
        }else{
            if(!regex.isNum(birth)){
                viewEvent.view_msg("안내","","생년월일은 숫자만 입력 가능합니다.",()=>{
                    webAccess.targetFocus(`${rootId} [data-id='oacx_birth']`);
                    $(`${rootId} [data-id='oacx_birth']`).val("");
                });
                return false;
            }
            if(!regex.isBirth(birth)){
                viewEvent.view_msg("안내","","생년월일을 다시 입력하여 주십시오.",()=>{
                    webAccess.targetFocus(`${rootId} [data-id='oacx_birth']`);
                    $(`${rootId} [data-id='oacx_birth']`).val("");
                });
                return false;
            }
            return true;
        }
    },
    ss1NumCheck: (num1)=>{        
        // 본인인증(Nice) CompareCI False 그리고 삼성패스일 때 생년월일, 주민등록번호 제외
        if(Provider.compareCI == false && providerChk.isSamsung(Provider.providerId)){
            return true;
        }

        if(num1==""){
            viewEvent.view_msg("안내","","주민등록번호를 입력하여 주십시오.",()=>{
                webAccess.targetFocus(`${rootId} [data-id='oacx_num1']`);
            });
            return false;
        }else{
            if(!regex.isNum(num1)){
                viewEvent.view_msg("안내","","주민등록번호는 숫자만 입력 가능합니다.",()=>{
                    webAccess.targetFocus(`${rootId} [data-id='oacx_num1']`);
                    $(`${rootId} [data-id='oacx_num1']`).val("");
                });
                return false;
            }
            return true;
        }
    },
    ss2NumCheck: (num2)=>{
        //키보드 * 처리
        if(mTransKey.isMasking(num2)){
            return true
        }
        
        // 본인인증(Nice) CompareCI False 그리고 삼성패스일 때 생년월일, 주민등록번호 제외
        if(Provider.compareCI == false && providerChk.isSamsung(Provider.providerId)){
            return true;
        }
        
        if(num2==""){
            viewEvent.view_msg("안내","","주민등록번호를 입력하여 주십시오.",()=>{
                webAccess.targetFocus(`${rootId} [data-id='oacx_num2']`);
            });
            return false;
        }else{
            if(!regex.isNum(num2)){
                viewEvent.view_msg("안내","","주민등록번호는 숫자만 입력 가능합니다.",()=>{
                    webAccess.targetFocus(`${rootId} [data-id='oacx_num2']`);
                    $(`${rootId} [data-id='oacx_num2']`).val("");
                });
                return false;
            }
            return true;
        }
    },
    ssCheck: (num1, num2)=>{
        //키보드 * 처리
        if(mTransKey.isMasking(num2)){
            return true
        }

        // 본인인증(Nice) CompareCI False 그리고 삼성패스일 때 생년월일, 주민등록번호 제외
        if(Provider.compareCI == false && providerChk.isSamsung(Provider.providerId)){
            return true;
        }
        if(num1 == ""){
            viewEvent.view_msg("안내","","주민등록번호를 입력하여 주십시오.", ()=>{
                webAccess.targetFocus(`${rootId} [data-id='oacx_num1']`);
            });
            return false;
        }else if(num2 == ""){
            viewEvent.view_msg("안내","","주민등록번호를 입력하여 주십시오.", ()=>{
                webAccess.targetFocus(`${rootId} [data-id='oacx_num2']`);
            });
            return false;
        }else{
            if(!regex.isValidBirthday(regex.convertBirthDay(num1, num2))){
                viewEvent.view_msg("안내","","주민등록번호를 다시 입력하여 주십시오.", ()=>{
                    webAccess.targetFocus(`${rootId} [data-id='oacx_num1']`);
                    $(`${rootId} [data-id='oacx_num1']`).val("");
                    $(`${rootId} [data-id='oacx_num2']`).val("");
                });
                return false;
            }
            if(!regex.isValidRnNum(num1, num2)){
                viewEvent.view_msg("안내","","주민등록번호를 다시 입력하여 주십시오.", ()=>{
                    webAccess.targetFocus(`${rootId} [data-id='oacx_num1']`);
                    $(`${rootId} [data-id='oacx_num1']`).val("");
                    $(`${rootId} [data-id='oacx_num2']`).val("");
                });
                return false;
            }
            return true;
        }
    },
    telcoTycdCheck: ()=>{
        var telcoTycd = $(`${rootId} form select[data-id='oacx_phone0'] option:not([disabled=disabled]):selected`).val();
        if(telcoTycd === undefined || telcoTycd == ""){
            viewEvent.view_msg("안내","","통신사를 선택해주세요.", ()=>{
                webAccess.targetFocus(`${rootId} [data-id='oacx_phone0']`);
            });
            return false;
        }
        return true;
    },
    phoneCheck: (phone, providerId)=>{
        if(phone == ""){
            viewEvent.view_msg("안내","","휴대폰번호를 입력하여 주십시오.", ()=>{
                webAccess.targetFocus(`${rootId} [data-id='oacx_phone2']`);
                /* if(providerChk.isPass(Provider.providerId)){
                    webAccess.targetFocus(`${rootId} [data-id='oacx_phone3']`);
                }else{
                    webAccess.targetFocus(`${rootId} [data-id='oacx_phone2']`);
                } */
            });
            return false;
        }else{
            if(!regex.isNum(phone)){
                viewEvent.view_msg("안내","","휴대폰번호는 숫자만 입력 가능합니다.", ()=>{
                    if(providerChk.isPass(providerId)){
                        webAccess.targetFocus(`${rootId} [data-id='oacx_phone3']`);
                    }else{
                        webAccess.targetFocus(`${rootId} [data-id='oacx_phone2']`);
                    }
                });
                return false;
            }
            if(phone.length < 7){
                viewEvent.view_msg("안내","","휴대폰번호를 다시 입력하여 주십시오.", ()=>{
                    if(providerChk.isPass(providerId)){
                        webAccess.targetFocus(`${rootId} [data-id='oacx_phone3']`);
                    }else{
                        webAccess.targetFocus(`${rootId} [data-id='oacx_phone2']`);
                    }
                });
                return false;
            }
            return true;
        }
    },
    checkBoxVaild: ()=>{

        const policy1 =$(`${rootId} #oacx_policy1`).prop("checked");
        const policy2 =$(`${rootId} #oacx_policy2`).prop("checked");
        const policy3 =$(`${rootId} #oacx_policy3`).prop("checked");
        const policy4 =$(`${rootId} #oacx_policy4`).prop("checked");
        
        if((!policy1 && policy1 != undefined) || 
            (!policy2 && policy2 != undefined) || 
            (!policy3 && policy3 != undefined) || 
            (!policy4 && policy4 != undefined)){
            viewEvent.view_msg("안내","","간편인증 서비스 이용에 대한 필수항목 동의를 하여야 합니다.", ()=>{
                $(`${rootId} #oacx_total`).focus();
            });
            return false;
        }

        //개인정보 이용 동의 확인 여부
        Provider.userInfo.privacy = policy1 ? 1:0;

        //서비스 이용약관 동의 확인 여부
        Provider.userInfo.policy3 = policy2 ? 1:0;

        //제3자 정보제공약관 확인 여부
        Provider.userInfo.policy4 = policy3 ? 1:0;

        //고유식별정보처리 동의 확인 여부
        Provider.userInfo.terms = policy4 ? 1:0;

        return true;
    },
    inputSizeCheck: ()=>{
        function getNumValue(e){
            var value =  $(e.currentTarget).val();
            if(!regex.isNum(value)){
                $(e.currentTarget).val(value.substr(0,value.length-1));
            }
        }
        function getMaxValue(e,size){
            var value =  $(e.currentTarget).val();  
            if(value.length >= size){
                $(e.currentTarget).val(value.substr(0,size-1));
            }
        }
        $(`${rootId} [data-id='oacx_num1'],
        ${rootId} [data-id='oacx_num2'],
        ${rootId} [data-id='oacx_birth'], 
        ${rootId} [data-id='oacx_phone2'], 
        ${rootId} [data-id='oacx_phone3']`).on("change keyup paste click", function(e){
            var value =  $(e.currentTarget).val();
            if(!regex.isNum(value)){
                $(e.currentTarget).val("");
            }
        });
        $(`${rootId} [data-id='oacx_name']`).on("propertychange change keydown input", (e)=>{
            getMaxValue(e,50);
         })
        $(`${rootId} [data-id='oacx_phone2'], ${rootId} [data-id='oacx_phone3']`).on("propertychange change keydown input", (e)=>{
            getNumValue(e);
            getMaxValue(e,9);
         })
        $(`${rootId} [data-id='oacx_birth']`).on("propertychange change keydown input", (e)=>{
            getNumValue(e);
            getMaxValue(e,9);
         })
        $(`${rootId} [data-id='oacx_num1']`).on("propertychange change keydown input", (e)=>{
            getNumValue(e);
            getMaxValue(e,7);
         })
        $(`${rootId} [data-id='oacx_num2']`).on("propertychange change keydown input", (e)=>{
            getNumValue(e);
            getMaxValue(e,8);
         })
    },
    isSignedData: ()=>{
        if(Provider.contentInfo.signType === "ENT_SIMPLE_SIGN" &&
           Provider.contentInfo.signTarget === ""){
            viewEvent.view_msg("안내","","서명 원문데이터를 입력하여 주십시오.");
        }
    }
}